import { FormEvent } from "react";
import { PasswordRule } from "../../types/admin";
import { PasswordRuleList } from "./PasswordRuleList";
import { TranslationKey } from "../../../shared/i18n/i18n";

type PasswordResetViewProps = {
  isSubmitDisabled: boolean;
  isSubmitting: boolean;
  newPassword: string;
  onBackToSignIn: () => void;
  onNewPasswordChange: (value: string) => void;
  onSubmit: (event: FormEvent) => Promise<void>;
  passwordPattern: string;
  passwordRequirements: string;
  rules: PasswordRule[];
  t: (key: TranslationKey) => string;
};

export const PasswordResetView = ({
  isSubmitDisabled,
  isSubmitting,
  newPassword,
  onBackToSignIn,
  onNewPasswordChange,
  onSubmit,
  passwordPattern,
  passwordRequirements,
  rules,
  t,
}: PasswordResetViewProps) => {
  return (
    <div className="forgot-layout">
      <form
        autoComplete="off"
        className="auth-form"
        onSubmit={(event) => void onSubmit(event)}
      >
        <label className="field">
          <span>{t("admin.field.newPassword")}</span>
          <input
            minLength={16}
            onChange={(event) => onNewPasswordChange(event.target.value)}
            pattern={passwordPattern}
            required
            title={passwordRequirements}
            type="password"
            value={newPassword}
          />
        </label>
        <PasswordRuleList rules={rules} />
        <button
          className="primary-button"
          disabled={isSubmitDisabled}
          type="submit"
        >
          {isSubmitting ? t("admin.button.updating") : t("admin.button.setNewPassword")}
        </button>
      </form>
      <button
        className="link-button inline-link"
        onClick={onBackToSignIn}
        type="button"
      >
        {t("admin.link.backToSignIn")}
      </button>
    </div>
  );
};
